// extracted by mini-css-extract-plugin
export default {"root":"_2Rk3i","variant-subscriptions":"_212Lf","variantSubscriptions":"_212Lf","variant-adoptables":"tdHU0","variantAdoptables":"tdHU0"};